import { render, staticRenderFns } from "./MStoreDefaultKanbanCard.vue?vue&type=template&id=20c367d0&"
import script from "./MStoreDefaultKanbanCard.vue?vue&type=script&lang=ts&"
export * from "./MStoreDefaultKanbanCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports